import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { secondaryButtonClasses } from "@/constants/ui";
import { useCancelBookingDialog } from "../useCancelBookingDialog";

export const SlotRestrictionScreen = () => {
  const { onClose } = useCancelBookingDialog();
  return (
    <div data-testid="cancel-dialog-slot-restricted" className="w-full flex flex-col items-center text-center bg-white rounded-xl my-4 p-8 gap-4">
      <div className="flex items-center justify-center h-14 w-14 rounded-full bg-amber-50">
        <Lock className="h-7 w-7 text-amber-600" />
      </div>
      <h2 className="text-2xl font-semibold">Slot bookings are managed by staff</h2>
      <p className="text-sm text-gray-600 max-w-md">Your slot is managed on your behalf. Please contact your practice manager to change or cancel it.</p>
      <Button variant="outline" className={`mt-2 ${secondaryButtonClasses}`} onClick={onClose}>Close</Button>
    </div>
  );
};
